import React, { useEffect } from 'react';
const Careers = () => {
  useEffect(() => {
    window.location.href = 'https://aec.edu.in/rdecs2025/';
  }, [])
  return (
  <></>    
  )
}

export default Careers;